import store from '../store/Store';

/**
 * Util to get the page origin
 */
export default function getPageOrigin(): string {
    return store.pbpPublishingSetting.publishingSettings.PageOrigin ?? '';
}
